import { render, staticRenderFns } from "./LandingPageCompanies.vue?vue&type=template&id=5d79f51c"
import script from "./LandingPageCompanies.vue?vue&type=script&lang=js"
export * from "./LandingPageCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports